import type { FAQPage, Question, WithContext } from 'schema-dts';
import { plainText } from 'src/areas/editorial-content/components/slices/rich-text';
import type { PrismicSliceFaqItem, PrismicSliceFaqSection } from 'src/types';

export function faqPage(
  faqData: PrismicSliceFaqSection
): WithContext<FAQPage> | null {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.items.filter(Boolean).map(f => faqSchema(f)) || [],
  };
}

export function faqSchema(faq: PrismicSliceFaqItem): Question {
  return {
    '@type': 'Question',
    name: plainText(faq.question),
    acceptedAnswer: {
      '@type': 'Answer',
      text: plainText(faq.answer),
    },
  };
}
